<template>
    <div>
        <nav aria-label="Page navigation example">
            <ul class="pagination pagination-md justify-content-center">
                <li class="page-item">
                  <span class="page-link text-dark" href="#">{{ $t('page') }} <b>{{ pagination.meta.current_page }}</b> {{ $t('of') }} <b>{{ pagination.meta.last_page }}</b></span>
                </li>

                <li v-bind:class="[{disabled: !pagination.links.next }]" class="page-item">
                  <a href="#" class="page-link" @click.prevent="allData(pagination.links.next)"><b>{{ $t('load_more') }}</b></a>
                </li>

                <li class="page-item sm-hidden xs-hidden">
                  <span class="page-link text-dark" href="#"> {{ $t('from') }} <b>{{ pagination.meta.from }}</b> {{ $t('to') }} <b>{{ pagination.meta.to }}</b> {{ $t('out_of') }} <b>{{ pagination.meta.total }}</b></span>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'Pagination',
    props: {
        pagination: {
            type: Object,
            default: () => {
                return {}
            },
            description: 'Pagination variable',
        },
        allData: {
            type: Function,
            default: () => {
                return [{}]
            },
            description: 'Function to reffresh data',
        },
    },
}
</script>
